import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center justify-center" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { id: "photoPlayIndex" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("/")
const _hoisted_5 = { id: "photoCount" }
const _hoisted_6 = { class: "flex flex-row justify-center" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "flex flex-row justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabelText = _resolveComponent("LabelText")!
  const _component_IconButton = _resolveComponent("IconButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.playbackState == 'playing' || _ctx.playbackState == 'paused')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_LabelText, {
            testId: "photoPlayTitle",
            label: "label.name",
            text: _ctx.title
          }, null, 8, ["text"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.playbackIndex), 1),
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.total), 1),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_IconButton, {
              testId: "playbackPrevious",
              icon: "skip_previous",
              onClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.previous()))
            }),
            (_ctx.playbackState == 'playing')
              ? (_openBlock(), _createBlock(_component_IconButton, {
                  key: 0,
                  testId: "playbackPause",
                  icon: "pause",
                  onClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pause()))
                }))
              : _createCommentVNode("", true),
            (_ctx.playbackState == 'paused')
              ? (_openBlock(), _createBlock(_component_IconButton, {
                  key: 1,
                  testId: "playbackStop",
                  icon: "stop",
                  onClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.stop()))
                }))
              : _createCommentVNode("", true),
            (_ctx.playbackState == 'paused')
              ? (_openBlock(), _createBlock(_component_IconButton, {
                  key: 2,
                  testId: "playback",
                  icon: "play_arrow",
                  onClicked: _cache[3] || (_cache[3] = ($event: any) => (_ctx.playback()))
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_IconButton, {
              testId: "playbackNext",
              icon: "skip_next",
              onClicked: _cache[4] || (_cache[4] = ($event: any) => (_ctx.next()))
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_LabelText, {
            testId: "photoCount",
            "text-color": "justify-center",
            label: "label.totalCount",
            text: String(_ctx.total)
          }, null, 8, ["text"]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_IconButton, {
              testId: "playback",
              icon: "play_arrow",
              onClicked: _cache[5] || (_cache[5] = ($event: any) => (_ctx.playback()))
            })
          ])
        ]))
  ]))
}